import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeUnmount, ref, watch } from "vue";
import { ElInput } from "element-plus";
import { registerFlowInputFlusher } from "@/flow/application/conditionInputFlushRegistry";


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteNameInput',
  props: {
    id: {},
    modelValue: {}
  },
  emits: ["preview", "commit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const draft = ref(props.modelValue);
let dirty = false;

function onInput(value: string) {
  draft.value = value;
  dirty = true;
  emit("preview", value);
}

function commit() {
  if (!dirty) {
    return;
  }
  dirty = false;
  emit("commit", draft.value);
}

const unregisterFlusher = registerFlowInputFlusher(commit);

watch(
  () => props.modelValue,
  (value) => {
    if (!dirty) {
      draft.value = value;
    }
  }
);

onBeforeUnmount(() => {
  commit();
  unregisterFlusher();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElInput), {
    id: _ctx.id,
    size: "mini",
    "model-value": draft.value,
    onInput: onInput,
    onBlur: commit
  }, null, 8, ["id", "model-value"]))
}
}

})